import { useTranslation } from 'react-i18next';
import { useFeature } from '@mafc/appshell';

import BlockTitle from 'common/BlockTitle';
import LoyaltyPoints from '../LoyaltyPoints';
import Promo from '../Promo';
import useLoyaltyNDiscount from 'pages/Checkout/components/Payment/hooks/useLoyaltyNDiscount';
import useLoyaltyPointsEffects from '../LoyaltyPoints/hooks/useLoyalyPointsEffects.hooks';
import AvailablePromotions from '../AvailablePromotions';

const LoyaltyAndDiscount = () => {
  const { t } = useTranslation();
  const isAvailablePromotionEnabled = useFeature('checkout.available_promotion.enabled').on;

  // calls an API to fetch users loyalty points
  useLoyaltyPointsEffects();

  const {
    isPaymentLoading,
    shouldShowSection,
    shouldShowLoyalty,
    shouldShowPromo,
  } = useLoyaltyNDiscount();

  return shouldShowSection ? (
    <>
      <BlockTitle>{t('shipmentLayout.loyalty&Discounts')}</BlockTitle>

      {shouldShowLoyalty && <LoyaltyPoints loading={isPaymentLoading} />}

      {shouldShowPromo && (isAvailablePromotionEnabled ? <AvailablePromotions /> : <Promo />)}
    </>
  ) : (
    <></>
  );
};

export default LoyaltyAndDiscount;
